import './EndScreen.css';

export const EndScreen = ({
  score,
  wordsGuessed,
  wrongAnswers,
  passesUsed,
  wordsHistory = [],
  onRestart,
  onHome,
  onChangeRoles,
  isMultiplayer = false,
  isHost = false,
  isRestartLoading = false,
  allPlayersPresent = true,
}) => (
  <div className="end-screen u-fade-in">
    <div className="end-screen__main">
      <div className="end-screen__stats">
        <div className="end-screen__left">
          <h1 className="end-screen__title">Tempo Scaduto!</h1>
          <div className="end-screen__score">
            <span className="end-screen__score-value">{score}</span>
            <span className="end-screen__score-label">PUNTI</span>
          </div>
        </div>

        <div className="end-screen__right">
          <div className="end-stat end-stat--correct">
            <span className="end-stat__v">{wordsGuessed}</span>
            <span className="end-stat__l">Indovinate</span>
          </div>
          <div className="end-stat end-stat--wrong">
            <span className="end-stat__v">{wrongAnswers}</span>
            <span className="end-stat__l">Sbagliate</span>
          </div>
          <div className="end-stat end-stat--pass">
            <span className="end-stat__v">{passesUsed}</span>
            <span className="end-stat__l">Passi usati</span>
          </div>
        </div>
      </div>

      <div className="end-screen__history">
        <h3 className="end-history__title">Cronologia Parole</h3>
        <div className="end-history__list">
          {wordsHistory.length > 0 ? (
            wordsHistory.map((item, idx) => (
              // eslint-disable-next-line react/no-array-index-key
              <div
                key={`${item.result}-${item.word}-${idx}`}
                className={`end-history__item end-history__item--${item.result}`}
              >
                <span className="end-history__word">
                  {item.word}
                  {item.double ? (
                    <span className="end-history__double-badge" title="Raddoppio">
                      ⚡
                    </span>
                  ) : null}
                </span>
                <span className="end-history__status">
                  {item.result === 'correct' ? '✓' : item.result === 'wrong' ? '✗' : '→'}
                </span>
              </div>
            ))
          ) : (
            <p className="end-history__empty">Nessuna parola giocata</p>
          )}
        </div>
      </div>
    </div>

    <div className="end-screen__footer">
      <button className="home-btn" onClick={onHome}>
        Home
      </button>

      {isMultiplayer && isHost && onChangeRoles && allPlayersPresent ? (
        <button className="changeroles-btn" onClick={onChangeRoles} id="btn-change-roles">
          Cambia Ruoli
        </button>
      ) : null}

      {isMultiplayer && !allPlayersPresent ? (
        // Someone left after the game ended — block restart to avoid a <3 player game
        <p className="end-screen__waiting">Un giocatore ha lasciato la stanza…</p>
      ) : !isMultiplayer || isHost ? (
        <button className="restart-btn" onClick={onRestart} disabled={isRestartLoading}>
          {isMultiplayer ? 'Rigioca' : 'Gioca ancora'}
        </button>
      ) : (
        <p className="end-screen__waiting">In attesa dell'host per rigiocare…</p>
      )}
    </div>
  </div>
);
